// @flow
import React from 'react'
import HeadColumn from './HeadColumn'
import { translateFunc, translations } from '../../shared/localize'
import { HeaderCell, HeaderRow } from '../MainTable'
import styled from 'styled-components'

const SwitcherHeaderCell = styled(HeaderCell)`
  width: 6%;
  text-align: left;
`

const t = translateFunc(translations.advertisement_table_thead)

export default function Thead() {
  return (
    <thead>
      <HeaderRow>
        <HeadColumn
          field="advertisement-checkbox"
          className="advertisements-table__checkbox-column"
          align="left"
        />
        <SwitcherHeaderCell />
        <HeadColumn
          field="advertisement"
          className="advertisements-table__advertisement-column"
          name={t('advertisement')}
          align="left"
        />
        <HeadColumn
          field="statuses"
          className="advertisements-table__statuses-column"
          name={t('moderation')}
          notSortable
          align="left"
        />
        <HeadColumn
          field="spent"
          className="advertisements-table__spent-column"
          name={t('spent')}
          calculatedField
        />
        <HeadColumn
          field="impressions"
          className="advertisements-table__impressions-column"
          name={t('impressions')}
          calculatedField
        />
        <HeadColumn
          field="clicks"
          className="advertisements-table__clicks-column"
          name={t('clicks')}
          calculatedField
        />
        <HeadColumn
          field="ctr"
          className="advertisements-table__ctr-column"
          name={t('ctr')}
          calculatedField
        />
        <HeadColumn
          field="cpc"
          className="advertisements-table__cpc-column"
          name={t('cpc')}
          calculatedField
        />
        <HeadColumn
          field="cpm"
          className="advertisements-table__cpm-column"
          name={t('cpm')}
          calculatedField
        />
        <HeadColumn
          field="goals"
          className="advertisements-table__goal-price-column"
          name={t('goals')}
        />
        <HeadColumn
          field="goalPrice"
          className="advertisements-table__goal-price-column"
          name={t('goal_price')}
          calculatedField
        />
        <HeadColumn
          field="goalPercentage"
          className="advertisements-table__conversion-column"
          name={t('goal_percentage')}
          calculatedField
        />
        <th />
      </HeaderRow>
    </thead>
  )
}
